var app = angular.module("leonardo");

var DeletedProperties = function($scope, $rootScope, $timeout, $controller, $q, PropertyService, FilterService) {

  $scope.properties = [];
  $scope.portfolios = [];
  $scope.portfolioExpanded = null;

  $scope.togglePortfolio = function(portfolio) {
    if ($scope.portfolioExpanded == portfolio) {
      $scope.portfolioExpanded = null;
      return;
    }
    $scope.portfolioExpanded = portfolio;
  };

  $scope.isPortfolioExpanded = function(portfolio) {
    return $scope.portfolioExpanded == portfolio;
  };

  $scope.getIndex = function(id) {
    var index = -1;
    angular.forEach($scope.portfolios, function(value, key){
      if (value.id == id) {
        index = key;
      }
    });
    return index;
  };

  $scope.groupProperties = function() {
    $scope.portfolios = [];
    angular.forEach($scope.properties, function (value) {
      var portfolio_id = (value.portfolio && value.portfolio.id) ? value.portfolio.id : value.portfolio;
      var portfolio_name = (value.portfolio && value.portfolio.name) ? value.portfolio.name : '';
      if ($scope.getIndex(portfolio_id) < 0) {
        $scope.portfolios.push({id: portfolio_id, name: portfolio_name, properties: []});
      }
      $scope.portfolios[$scope.getIndex(portfolio_id)].properties.push(value);
    });
  };

  $scope.getEntitiesPromise = function(options) {
    options['summary'] = true;
    options['search'] = FilterService.getFilter('search');
    options['account'] = FilterService.getFilter('account_reports');
    options['group'] = FilterService.getFilter('group_reports');
    options['portfolio__id'] = FilterService.getFilter('portfolio_reports');
    var defer = $q.defer();
    PropertyService.getDeleted(options).then(function(list) {
      $scope.properties = list.results ? list.results : list;
      $scope.groupProperties();
      defer.resolve(list);
    }, function(error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  $scope.active = function(property) {
    property.unDelete().then(function() {
      $scope.loadPage($scope.page);
    });
  };

  $controller('TableFilterController', { $scope: $scope });


  $scope.loadPage(1);

};

app.controller('DeletedProperties', ['$scope', '$rootScope', '$timeout', '$controller', '$q', 'PropertyService',
  'FilterService', DeletedProperties]);
